import { render, staticRenderFns } from "./WorkplaceSelect.vue?vue&type=template&id=71ec1402&scoped=true&"
import script from "./WorkplaceSelect.vue?vue&type=script&lang=ts&"
export * from "./WorkplaceSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec1402",
  null
  
)

export default component.exports